// extracted by mini-css-extract-plugin
export var tosLink = "_dt-0";